export const selectCurrentTenantMembers = (state) => {
  return (
    state.tenants?.currentTenantMembers ||
    state.tenants?.allTenants[state.tenants?.selectedTenant].members
  )
}
